export default "__VITE_ASSET__B8oOaD5H__"